const CART_RESERVE_DURATION_MS = 10 * 60 * 1000;
const CART_TIMER_END_KEY = 'cart_timer_end';
const CART_TIMER_COUNT_KEY = 'cart_timer_count';

let cartReserveTickId = null;

function formatCartReserveTime(ms) {
  const totalSeconds = Math.max(0, Math.floor(ms / 1000));
  const minutes = Math.floor(totalSeconds / 60);
  const seconds = totalSeconds % 60;
  return `${String(minutes).padStart(2, '0')}:${String(seconds).padStart(2, '0')}`;
}

function readStoredNumber(key) {
  try {
    const stored = Number.parseInt(window.localStorage.getItem(key), 10);
    return Number.isNaN(stored) ? null : stored;
  } catch (error) {
    return null;
  }
}

function writeStoredNumber(key, value) {
  try {
    window.localStorage.setItem(key, String(value));
  } catch (error) {
    /* storage blocked */
  }
}

function getCartTimerEnd() {
  return readStoredNumber(CART_TIMER_END_KEY);
}

function getCartTimerCount() {
  return readStoredNumber(CART_TIMER_COUNT_KEY);
}

function startCartTimer() {
  const endsAt = Date.now() + CART_RESERVE_DURATION_MS;
  writeStoredNumber(CART_TIMER_END_KEY, endsAt);
  return endsAt;
}

function clearCartTimer() {
  try {
    window.localStorage.removeItem(CART_TIMER_END_KEY);
    window.localStorage.removeItem(CART_TIMER_COUNT_KEY);
  } catch (error) {
    /* storage blocked */
  }
}

function getReserveElements() {
  const root = document.querySelector('[data-cart-reserve]');
  if (!root) return {};

  return {
    root,
    drawer: document.querySelector('cart-drawer'),
    timeEl: root.querySelector('[data-cart-reserve-time]'),
    activeMessage: root.querySelector('[data-cart-reserve-active]'),
    expiredMessage: root.querySelector('[data-cart-reserve-expired]'),
    cartUrl: root.dataset.cartUrl || '/cart.js',
  };
}

function renderCartReserve() {
  const { root, drawer, timeEl, activeMessage, expiredMessage } = getReserveElements();
  if (!root) return;

  if (drawer?.classList.contains('is-empty')) {
    root.hidden = true;
    root.classList.remove('is-expired');
    if (activeMessage) activeMessage.hidden = false;
    if (expiredMessage) expiredMessage.hidden = true;
    return;
  }

  const endsAt = getCartTimerEnd();
  if (!endsAt) {
    root.hidden = true;
    return;
  }

  const remaining = endsAt - Date.now();
  const expired = remaining <= 0;

  root.hidden = false;
  root.classList.toggle('is-expired', expired);

  if (activeMessage) activeMessage.hidden = expired;
  if (expiredMessage) expiredMessage.hidden = !expired;
  if (timeEl) timeEl.textContent = expired ? '00:00' : formatCartReserveTime(remaining);
}

function syncCartReserveFromCart(cart) {
  const count = Number.parseInt(cart?.item_count, 10) || 0;
  const previousCount = getCartTimerCount();

  if (count <= 0) {
    clearCartTimer();
    renderCartReserve();
    return;
  }

  const countIncreased = previousCount != null && count > previousCount;
  writeStoredNumber(CART_TIMER_COUNT_KEY, count);

  if (countIncreased || !getCartTimerEnd()) {
    startCartTimer();
  }

  renderCartReserve();
}

function cartUrlFromDom() {
  return getReserveElements().cartUrl || '/cart.js';
}

function fetchCartAndSync() {
  return fetch(cartUrlFromDom(), {
    credentials: 'same-origin',
    headers: { Accept: 'application/json' },
  })
    .then((response) => (response.ok ? response.json() : null))
    .then((cart) => {
      if (cart) syncCartReserveFromCart(cart);
      else renderCartReserve();
    })
    .catch(() => {
      renderCartReserve();
    });
}

function onCartReserveUpdate(event) {
  const cart = event?.cartData;
  if (cart && typeof cart.item_count === 'number') {
    syncCartReserveFromCart(cart);
    return;
  }

  fetchCartAndSync();
}

function initCartReserveTimer() {
  renderCartReserve();
  fetchCartAndSync();

  if (cartReserveTickId) return;
  cartReserveTickId = window.setInterval(renderCartReserve, 1000);
}

window.initCartReserveTimer = initCartReserveTimer;

if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
  subscribe(PUB_SUB_EVENTS.cartUpdate, onCartReserveUpdate);
}

document.addEventListener('DOMContentLoaded', initCartReserveTimer);
document.addEventListener('shopify:section:load', initCartReserveTimer);
